import { useState, useEffect } from "react";
import {
  usePostDialogMutation,
  usePostFollowUpMutation,
} from "../dialogsSlice";
import { useNavigate } from "react-router-dom";

const useCreateDialog = () => {
  const [newDialogMutation] = usePostDialogMutation();
  const [newFollowUpMutation] = usePostFollowUpMutation();
  const [creatingDialog, setCreatingDialog] = useState();
  const [topic, setTopic] = useState();
  const navigate = useNavigate();

  const postNewDialog = async ({ problemId, dialogId, followUp }) => {
    let result;
    try {
      setCreatingDialog(true);
      if (dialogId != null && followUp != null) {
        result = await newFollowUpMutation({
          dialogId,
          followUp,
        });
      } else {
        let body;
        if (problemId != null) {
          body = { problem_id: problemId };
        } else {
          body = { topic };
        }
        result = await newDialogMutation({
          body,
        });
      }
      if (result?.data?.dialog_id) {
        navigate(`/problems/${result?.data?.dialog_id}`);
      }
      setCreatingDialog(false);
    } catch (err) {
      console.error(err);
      setCreatingDialog(false);
    }
  };

  useEffect(() => {
    setTopic("AUTO");
    // eslint-disable-next-line
  }, []);

  return {
    creatingDialog,
    postNewDialog,
  };
};

export default useCreateDialog;
